import { UrlConstants } from "../url.constants";
export class ApiCloseoutConstants {
    static URL = UrlConstants.API_V2 + "Closeout";
}
